var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1925_55221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1925_55221)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0H0V1.06667H22V0ZM22 2.1332H0V3.19987H22V2.1332ZM0 4.2668H22V5.33346H0V4.2668ZM22 6.4H0V7.46667H22V6.4ZM0 8.5332H22V9.59987H0V8.5332ZM22 10.6668H0V11.7335H22V10.6668ZM0 12.8H22V13.8667H0V12.8ZM22 14.9332H0V15.9999H22V14.9332Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.42857,
    height: 7.46667,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1925_55221)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09523 1.60023C2.09523 1.89478 1.86071 2.13356 1.57142 2.13356C1.28212 2.13356 1.04761 1.89478 1.04761 1.60023C1.04761 1.30568 1.28212 1.06689 1.57142 1.06689C1.86071 1.06689 2.09523 1.30568 2.09523 1.60023ZM4.19046 1.60023C4.19046 1.89478 3.95595 2.13356 3.66666 2.13356C3.37736 2.13356 3.14285 1.89478 3.14285 1.60023C3.14285 1.30568 3.37736 1.06689 3.66666 1.06689C3.95595 1.06689 4.19046 1.30568 4.19046 1.60023ZM5.76189 2.13356C6.05119 2.13356 6.2857 1.89478 6.2857 1.60023C6.2857 1.30568 6.05119 1.06689 5.76189 1.06689C5.4726 1.06689 5.23808 1.30568 5.23808 1.60023C5.23808 1.89478 5.4726 2.13356 5.76189 2.13356ZM8.38094 1.60023C8.38094 1.89478 8.14642 2.13356 7.85713 2.13356C7.56784 2.13356 7.33332 1.89478 7.33332 1.60023C7.33332 1.30568 7.56784 1.06689 7.85713 1.06689C8.14642 1.06689 8.38094 1.30568 8.38094 1.60023ZM2.61902 3.20036C2.90831 3.20036 3.14283 2.96158 3.14283 2.66702C3.14283 2.37247 2.90831 2.13369 2.61902 2.13369C2.32973 2.13369 2.09521 2.37247 2.09521 2.66702C2.09521 2.96158 2.32973 3.20036 2.61902 3.20036ZM5.23808 2.66702C5.23808 2.96158 5.00357 3.20036 4.71427 3.20036C4.42498 3.20036 4.19046 2.96158 4.19046 2.66702C4.19046 2.37247 4.42498 2.13369 4.71427 2.13369C5.00357 2.13369 5.23808 2.37247 5.23808 2.66702ZM6.80953 3.20036C7.09882 3.20036 7.33334 2.96158 7.33334 2.66702C7.33334 2.37247 7.09882 2.13369 6.80953 2.13369C6.52024 2.13369 6.28572 2.37247 6.28572 2.66702C6.28572 2.96158 6.52024 3.20036 6.80953 3.20036ZM8.38094 3.73343C8.38094 4.02798 8.14642 4.26676 7.85713 4.26676C7.56784 4.26676 7.33332 4.02798 7.33332 3.73343C7.33332 3.43888 7.56784 3.2001 7.85713 3.2001C8.14642 3.2001 8.38094 3.43888 8.38094 3.73343ZM5.76188 4.26676C6.05117 4.26676 6.28569 4.02798 6.28569 3.73343C6.28569 3.43888 6.05117 3.2001 5.76188 3.2001C5.47259 3.2001 5.23807 3.43888 5.23807 3.73343C5.23807 4.02798 5.47259 4.26676 5.76188 4.26676ZM4.19048 3.73343C4.19048 4.02798 3.95596 4.26676 3.66667 4.26676C3.37738 4.26676 3.14286 4.02798 3.14286 3.73343C3.14286 3.43888 3.37738 3.2001 3.66667 3.2001C3.95596 3.2001 4.19048 3.43888 4.19048 3.73343ZM1.57142 4.26676C1.86071 4.26676 2.09523 4.02798 2.09523 3.73343C2.09523 3.43888 1.86071 3.2001 1.57142 3.2001C1.28212 3.2001 1.04761 3.43888 1.04761 3.73343C1.04761 4.02798 1.28212 4.26676 1.57142 4.26676ZM3.14285 4.80023C3.14285 5.09478 2.90833 5.33356 2.61904 5.33356C2.32974 5.33356 2.09523 5.09478 2.09523 4.80023C2.09523 4.50568 2.32974 4.26689 2.61904 4.26689C2.90833 4.26689 3.14285 4.50568 3.14285 4.80023ZM4.71427 5.33356C5.00357 5.33356 5.23808 5.09478 5.23808 4.80023C5.23808 4.50568 5.00357 4.26689 4.71427 4.26689C4.42498 4.26689 4.19046 4.50568 4.19046 4.80023C4.19046 5.09478 4.42498 5.33356 4.71427 5.33356ZM7.33332 4.80023C7.33332 5.09478 7.0988 5.33356 6.80951 5.33356C6.52022 5.33356 6.2857 5.09478 6.2857 4.80023C6.2857 4.50568 6.52022 4.26689 6.80951 4.26689C7.0988 4.26689 7.33332 4.50568 7.33332 4.80023ZM7.85713 6.40036C8.14642 6.40036 8.38094 6.16158 8.38094 5.86702C8.38094 5.57247 8.14642 5.33369 7.85713 5.33369C7.56784 5.33369 7.33332 5.57247 7.33332 5.86702C7.33332 6.16158 7.56784 6.40036 7.85713 6.40036ZM6.28569 5.86702C6.28569 6.16158 6.05117 6.40036 5.76188 6.40036C5.47259 6.40036 5.23807 6.16158 5.23807 5.86702C5.23807 5.57247 5.47259 5.33369 5.76188 5.33369C6.05117 5.33369 6.28569 5.57247 6.28569 5.86702ZM3.66667 6.40036C3.95596 6.40036 4.19048 6.16158 4.19048 5.86702C4.19048 5.57247 3.95596 5.33369 3.66667 5.33369C3.37738 5.33369 3.14286 5.57247 3.14286 5.86702C3.14286 6.16158 3.37738 6.40036 3.66667 6.40036ZM2.09523 5.86702C2.09523 6.16158 1.86071 6.40036 1.57142 6.40036C1.28212 6.40036 1.04761 6.16158 1.04761 5.86702C1.04761 5.57247 1.28212 5.33369 1.57142 5.33369C1.86071 5.33369 2.09523 5.57247 2.09523 5.86702Z",
    fill: "url(#paint0_linear_1925_55221)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1925_55221",
    x: 1.04761,
    y: 1.06689,
    width: 7.33331,
    height: 6.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1925_55221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1925_55221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1925_55221",
    x1: 1.04761,
    y1: 1.06689,
    x2: 1.04761,
    y2: 6.40036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdFlag);
export default __webpack_public_path__ + "static/media/usd-flag.033912159afa721ee2a069e61d4a0268.svg";
export { ForwardRef as ReactComponent };